import { createSlice } from '@reduxjs/toolkit';
import type { IProjectBudget, IProjectSource, IProjectUse } from '../../../../types/Project';

interface ProjectBudgetStoreInterface {
  budget: IProjectBudget[];
  sources: IProjectSource[];
  uses: IProjectUse[];
}

const initialState: ProjectBudgetStoreInterface = {
  budget: [
    { name: 'Acquisition', amount: 0 },
    { name: 'Construction', amount: 0 },
    { name: 'Soft Cost', amount: 0 },
    { name: 'Finance Cost', amount: 0 },
    { name: 'Development Cost', amount: 0 },
  ],
  sources: [],
  uses: [],
};
export const ProjectBudgetSlice = createSlice({
  name: 'project-budget',
  initialState,
  reducers: {
    clearProjectBudget: (_state) => initialState,
    setProjectBudget(state, { payload }) {
      state.budget = payload;
    },
    setProjectSources(state, { payload }) {
      state.sources = payload;
    },
    setProjectUses(state, { payload }) {
      state.uses = payload;
    },
  },
});

export const { setProjectBudget, setProjectSources, setProjectUses, clearProjectBudget } = ProjectBudgetSlice.actions;

export default ProjectBudgetSlice.reducer;
